import { useLocation } from "react-router-dom";
import { SportTooltip } from "../../controls";

const NavMenuItem = ({label, url, img, onClick, disabled, tooltip, itemId, external, badgeCount = 0}) => {
  const location = useLocation();
  const class2 = !external && location.pathname === url ? ' nav-menu-item-selected' : ''
  const badge = badgeCount > 0 ? <span className="nav-menu-badge">{badgeCount}</span> : null;

  if (disabled)
    return <SportTooltip  title={tooltip}><div id={itemId} className={"nav-menu-item" + class2} >
      <div className="nav-menu-indicator"/>
      <img src={`/images/${img}`} alt="logo-img"/>
      {badge}
      <div>{label}</div>
    </div></SportTooltip>

  if (onClick)
      return <SportTooltip title={tooltip}><div id={itemId} className="nav-menu-item" onClick={onClick} style={{cursor: "pointer"}}>
        <img src={`/images/${img}`} alt="logo-img"/>
        {badge}
        <div>{label}</div>
      </div></SportTooltip>

  return <SportTooltip title={tooltip}><a id={itemId} href={url} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className={"nav-menu-item" + class2} >
    <div className="nav-menu-indicator"/>
    <img src={`/images/${img}`} alt="logo-img"/>
    {badge}
    <div>{label}</div>
  </a></SportTooltip>
}

export default NavMenuItem;